import Banner from '../../ui/Banner';
import DynamicZones, { DynamicZoneType } from '../DynamicZones';
import { Wrapper } from './styles';
import { Service, ServiceServiceDynamicDynamicZone, Technology } from '../../../types/schema';

export type AllServicesPageTemplateProps = {
  service: Service;
  serviceDynamic: ServiceServiceDynamicDynamicZone[];
  technologies?: Technology[];
  locale: string;
};

const AllServicesPageTemplate: React.FC<AllServicesPageTemplateProps> = ({
  service,
  serviceDynamic,
  technologies,
  locale,
}) => {
  return (
    <Wrapper>
      <Banner title={service.title} />
      <DynamicZones
        contentStyle={{ paddingTop: 30, paddingBottom: 30 }}
        dynamicZones={serviceDynamic as DynamicZoneType[]}
        allTechnologies={technologies}
        language={locale}
      />
    </Wrapper>
  );
};

export default AllServicesPageTemplate;
